import VideoStopOverlayIcon from '@atlaskit/icon/core/video-stop-overlay';
import * as React from 'react';

export function SvgStop() {
  return <VideoStopOverlayIcon label="" testId="ads-refreshed-icon" />;
}
